<template>
    <div>
        <multiselect
            v-model="selected"
            :class="validateError != '' ? 'box-border-color' : ''"
            :clear-on-select="!multiple"
            :close-on-select="!multiple"
            :deselect-label="''"
            :multiple="multiple"
            :options="options"
            :placeholder="$t('select')"
            :select-label="''"
            :selected-label="''"
            label="text"
            track-by="value"
            @input="handleInput($event, multiple)"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length && !isOpen">
	                {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError">
        </span>
    </div>
</template>

<script>
    // Helpers
    import handleInput from '@/helpers/handleInput';
    import setSelected from '@/helpers/setSelected';
    import translateNSelected from '@/helpers/translateNSelected';

    export default {
        props: {
            value: {
                default: null
            },
            options: {
                type: Array,
                default: []
            },
            multiple: {
                type: Boolean,
                default: true
            },
            validateError: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selected: null,
            }
        },
        watch: {
            value: function (newValue) {
                this.selected = this.setSelected(newValue, this.options, this.multiple)
            }
        },
        methods: {
            translateNSelected,
            handleInput,
            setSelected,
        }
    }
</script>
